import React from 'react';
import classNames from 'classnames';
import { formatToShortAndLongDate } from '../../../util/dates';
import { formatMoney } from '../../../util/currency';
import { NamedLink, UserDisplayName } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './SubscriptionItem.css';

const SubscriptionItem = props => {
  const { type, transaction, intl } = props;
  const { user, provider } = transaction;
  const isOrder = type === "order";

  // Wybór osoby po drugiej stronie transakcji
  const otherUser = isOrder ? provider : user;
  const customerName = !isOrder ? `${transaction.attributes.firstName} ${transaction.attributes.lastName}` : undefined;
  const otherUserDisplayName = <UserDisplayName user={otherUser} intl={intl} nameToDisplay={customerName} />;

  // LOGIKA DATY
  // Używamy createdAt jako daty rozpoczęcia subskrypcji
  const createdAtDate = transaction.attributes.createdAt;
  const formattedDates = formatToShortAndLongDate(intl, createdAtDate);

  // LOGIKA STATUSU
  const { processState, monthlyPrice } = transaction.attributes;

  // ROZBUDOWANE MAPOWANIE KLAS

  const linkClasses = classNames(css.itemLink, {
    [css.bannedUserLink]: otherUser?.attributes?.banned,
  });

  const isPaid = transaction.attributes.paid;
  const isActive = processState === 'active';

  const itemClasses = classNames(css.item, {
    [css.unpaidItem]: !isPaid && isActive,
  });

  const statusClasses = classNames(css.statusBadge, {
    [css.statusActive]: processState === 'active' && isPaid, // Zielony tylko gdy opłacona
    [css.statusAccepted]: processState === 'accepted',
    [css.statusPending]: processState === 'payment-pending' || !isPaid, // Pomarańczowy/Czerwony gdy problem
    [css.statusExpired]: processState === 'payment-expired' || processState === 'cancelled',
    [css.statusCompleted]: processState === 'completed',
    [css.statusError]: !isPaid && isActive// Nowa klasa dla błędu płatności
  });

  return (
    <li className={css.listItem}>
      <div className={itemClasses}>
        <NamedLink
          className={linkClasses}
          name={isOrder ? "SubscriptionOrderDetailsPage" : "SubscriptionSaleDetailsPage"}
          params={{ id: transaction.id.uuid }}
        >
          <div className={css.itemInfo}>
            <div className={css.itemUsername}>
              {otherUserDisplayName}
              {!isPaid && isActive && <span className={css.unpaidIcon} title="Problem z płatnością">⚠️</span>}
            </div>
            <div className={css.listingTitle}>
              {transaction.listing?.attributes?.title}
            </div>
            <p className={css.subscriptionLabel}>
              <span className={css.creationDate}>{formattedDates.short}</span>
            </p>
          </div>

          <div className={css.itemState}>
            <div className={statusClasses}>
              {(!isPaid && isActive) ? (
                <FormattedMessage id="SubscriptionItem.statusUnpaid" />
              ) : (
                <FormattedMessage id={`SubscriptionInboxPage.status.${processState}`} />
              )}
            </div>
            <div className={classNames(css.priceValue, { [css.priceError]: !isPaid && isActive })}>
              {monthlyPrice ? formatMoney(intl, monthlyPrice) : ''}
              <span className={css.perMonth}> / <FormattedMessage id="SubscriptionItem.perMonth" /></span>
            </div>
          </div>
        </NamedLink>
      </div>
    </li>
  );
};

export default SubscriptionItem;